/**
 * Set the webpack public path (for bundles) dynamically
 * The static path comes from the server
 * @type {string}
 * @private
 * @link https://github.com/webpack/docs/wiki/configuration#outputpublicpath
 */
__webpack_public_path__ = `${ globals.config.static }js/`; // eslint-disable-line



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/main/webpack-runtime-settings.js